import MainTabs from "components/V2/MainTabs/MainTabs";
import { FreelancerProfileWithRewards } from "types/FreelancerProfileWithRewards";
import Profile from "./Tabs/Profile/index.tab";
import ReferralHistory from "./Tabs/ReferralHistory/index.tab";
import TokenEarnings from "./Tabs/TokenEarnings/index.tab";

interface ITalentProfile {
    talent: FreelancerProfileWithRewards;
}

const TalentProfile = ({ talent }: ITalentProfile) => {
    return (
        <MainTabs
            tabNavigations={["profile", "referrals", "rewards"]}
            tabs={["Profile", "Referral history", "Token earnings"]}
            contents={[
                <Profile talent={talent} />,
                <ReferralHistory talent={talent} />,
                <TokenEarnings talent={talent} />,
            ]}
        />
    );
}

export default TalentProfile;